import styled from "styled-components";

import { BaseButton } from "shared/atoms/BaseButton";

export const LevelLockButton = styled(BaseButton)`
  &.active {
    background-color: ${({ theme }) => theme.colors.redesign.o10};
    color: ${({ theme }) => theme.colors.redesign.o100};
    border-color: ${({ theme }) => theme.colors.redesign.o100};
  }

  &.large {
    width: 40px;
    min-height: 40px;
  }
`;
